import { NavLink, useLocation, Link, useNavigate } from "react-router-dom";
import "./Header.css";
import { useState, useEffect, useRef } from "react";
import DynamicMeta from "../pages/Dynamicmeta";

export default function Header({ aboutRef }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [tools, setTools] = useState([]);
  const [activeMenu, setActiveMenu] = useState("");
  



  // Track manual scroll (About click)
  const isManualScroll = useRef(false);

  /* =========================
     FETCH BLOGS
  ========================== */
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/navbar", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setBlogs(data.html || []);
    } catch (err) {
      if(err.response?.status === 500)
      {
        navigate("/500");
      }
      else if(err.response?.status === 400)
      {
        navigate("/400");
      }
      else
      {
        navigate("/503");
      }
    }
  };

  /* =========================
     FETCH TOOLS
  ========================== */
  const fetchTools = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/toolnavbar", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setTools(data.html || []);
    } catch (err) {
      if(err.response?.status === 500)
      {
        navigate("/500");
      }
      else if(err.response?.status === 400)
      {
        navigate("/400");
      }
      else
      {
        navigate("/503");
      }
    }
  };

  /* =========================
     ABOUT CLICK (SCROLL)
  ========================== */
  const handleAboutScroll = (e) => {
    e.preventDefault();
    if (!aboutRef?.current) return;

    isManualScroll.current = true;

    aboutRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  /* =========================
     HOME CLICK (TOP SCROLL)
  ========================== */
  const handleHomeClick = () => {
    isManualScroll.current = false;
    setActiveMenu("home");

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleAboutClick = () => {
    isManualScroll.current = false;
    setActiveMenu("about");
    setTimeout(() => {
        aboutRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 50);
  };

  const handlePortfolioClick = () => {
    isManualScroll.current = false;
    setActiveMenu("ourportfolio");
  };



  /* =========================
     ROUTE CHANGE HANDLING
  ========================== */
  useEffect(() => {
    fetchBlogs();
    fetchTools();

    if (location.hash !== "#about-premium") return;

  const scroll = () => {
    const el = document.getElementById("about-premium");

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      requestAnimationFrame(scroll);
    }
  };

  scroll();

    // If only "/" clicked → scroll top
    if (location.pathname === "/" && !location.hash) {
      setActiveMenu("home");
      window.scrollTo({ top: 0, behavior: "smooth" });
      console.warn(activeMenu);
    }
  }, [location.pathname]);
  /* =========================
     JSX
  ========================== */
  return (
    <>
    <DynamicMeta />
    <nav className="navbar navbar-expand-lg bg-white sticky-top shadow-sm">
      <div className="container">
        {/* Logo */}
        <NavLink className="navbar-brand" to="/" onClick={handleHomeClick}>
          <img
            src="/graphics/images/logo.webp"
            alt="Code Inputs"
            width="110"
            height="40"
          />
        </NavLink>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse" id="mainNavbar">
          <ul className="navbar-nav mx-auto gap-lg-3">
            {/* HOME */}
            <li className="nav-item">
              <NavLink
                to="/"
                onClick={handleHomeClick}
                className={({ isActive }) =>
                  `nav-link ${
                    isActive &&
                    (activeMenu === "" || activeMenu === "home")
                      ? "active"
                      : ""
                  }`
                }
              >
                Home
              </NavLink>
            </li>

            {/* PORTFOLIO */}
            <li className="nav-item">
              <NavLink
                to="/ourportfolio"
                onClick={handlePortfolioClick}
                className={({ isActive }) =>
                  `nav-link ${
                    isActive &&
                    (activeMenu === "" || activeMenu === "ourportfolio")
                      ? "active"
                      : ""
                  }`
                }
              >
                Portfolio
              </NavLink>
            </li>

            {/* ABOUT */}
            <li className="nav-item">
              <NavLink
                to="/#about-premium"
                onClick={handleAboutClick}
                className={ ({ isActive }) =>`nav-link ${isActive && (activeMenu === "about") ? "active" : ""}`}
              >
                About Us
              </NavLink>
            </li>

            {/* BLOG */}
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
              >
                Blog <i className="bi bi-chevron-down dropdown-arrow"></i>
              </span>

              <ul className="dropdown-menu">
                {blogs.length === 0 && (
                  <li className="dropdown-item text-muted">
                    No items found
                  </li>
                )}

                {blogs.map((item, index) => (
                  <li key={item.id || index}>
                    <NavLink className="dropdown-item" to={`/${item.route}`}>
                      {item.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </li>

            {/* TOOLS */}
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
              >
                Tools <i className="bi bi-chevron-down dropdown-arrow"></i>
              </span>

              <ul className="dropdown-menu">
                {tools.length === 0 && (
                  <li className="dropdown-item text-muted">
                    No items found
                  </li>
                )}

                {tools.map((item, index) => (
                  <li key={item.id || index}>
                    <NavLink className="dropdown-item" to={`/${item.route}`}>
                      {item.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </li>

            {/* CONTACT */}
            <li className="nav-item">
              <NavLink className="nav-link" to="/contact">
                Contact Us
              </NavLink>
            </li>
          </ul>

          {/* CTA */}
          <NavLink to="/contact" className="btn btn-primary rounded-pill px-4">
            GET QUOTE
          </NavLink>
        </div>
      </div>
    </nav>
    </>
  );
}
